import { createRootRoute, Outlet, useRouterState } from "@tanstack/react-router"
import { HelmetProvider } from "@dr.pogodin/react-helmet"
import { Navigation } from "@/components/Navigation"
import { navigation, footer } from "@/content"
import { useEffect } from "react"

export const Route = createRootRoute({
  component: RootComponent,
})

function RootComponent() {
  const routerState = useRouterState()

  // Scroll to top on route changes
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [routerState.location.pathname])

  return (
    <HelmetProvider>
      <div className="min-h-screen bg-background text-foreground">
        <Navigation navigation={navigation} />
        <main>
          <div key={routerState.location.pathname} className="page-transition">
            <Outlet />
          </div>
        </main>
        <footer className="py-8 px-6 border-t border-border">
          <div className="max-w-6xl mx-auto">
            {footer.contact && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-6">
                <div className="text-center md:text-left">
                  <h3 className="font-semibold text-foreground mb-2">Office Location</h3>
                  <div className="text-sm text-muted-foreground space-y-1">
                    <p>{footer.contact.address.line1}</p>
                    <p>{footer.contact.address.line2}</p>
                    <p>{footer.contact.address.line3}</p>
                  </div>
                </div>
                <div className="text-center md:text-right">
                  <h3 className="font-semibold text-foreground mb-2">Contact</h3>
                  <div className="text-sm text-muted-foreground">
                    <p>
                      <a href={`tel:${footer.contact.phone}`} className="hover:text-foreground transition-colors">
                        {footer.contact.phone}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            )}
            <div className="text-center text-sm text-muted-foreground mt-6">
              <p>{footer.copyright}</p>
            </div>
          </div>
        </footer>
      </div>
    </HelmetProvider>
  )
}
